export * from '@entities/tieu-chuan/tieu-chuan.route';
export * from '@entities/tieu-chuan/tieu-chuan.service';
export * from '@entities/tieu-chuan/tieu-chuan/tieu-chuan.component';
